import { useEffect, useState } from "react";
import Drawer from "@material-ui/core/Drawer";
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import { getRightDrawerStatus, getElementOnFocus, getCodeEditStatus, getTabOnFocus } from '../../../store/global/selectors';
import { toggleRightDrawer, setIsDocumentClicked, triggerTour } from '../../../store/global/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getClusterlets } from '../../../store/constructs/clusterlets/selectors';
import { getEvents } from '../../../store/constructs/events/selectors';
import CancelIcon from '@material-ui/icons/Cancel';
import DigitalTwin from '../../tabs/DigitalTwin';
import Sensor from '../../tabs/Sensor';
import Delegate from '../../tabs/Delegate';
import Event from '../../tabs/Event';
import Analytics from '../../tabs/Analytics';
import Transaction from '../../tabs/Transaction';
import TemplateClusterlet from '../../tabs/TemplateClusterlet';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import { getAllTransactions } from '../../../store/constructs/transactions/selectors';
import { getTransactionState, getTransactionDrawnState } from '../../../store/global/selectors';
import { setTRansactionState, reRenderInfoBuilder, setDrawnTransaction, setNodeClicked, setDisablePan, setTabOnFocus, setFocusElement, resetImageMapData } from '../../../store/global/actions'
import User from '../../tabs/User';
import EventTypes from '../../tabs/EventTypes';
import { setLatestFieldAdded } from '../../../store/global/actions';
import { getTemplateClusterlets } from '../../../store/constructs/templated_clusterlet/selectors';
import View from '../../tabs/View';
import { getViews } from "../../../store/views/selectors";
import ViewSection from '../../tabs/ViewSection';
import ViewField from '../../tabs/ViewField';
import ViewUI from '../../tabs/ViewUI';
import Assets from '../../tabs/Assets';
import TemplateDelegate from '../../tabs/TemplateDelegate';
import SimulationTabs from '../../tabs/Simulation';
import { invokePostService } from "../../../store/global/actions";
import DrawerHeader from '../../atoms/drawerHeader';
import { getDetailsFromUrl } from '../../../services/blueprint';
import SimulationEvent from '../../tabs/SimulationEvent';
import SimulationTransaction from '../../tabs/SimulationTransaction';
import ChildSimulationTransaction from '../../tabs/ChildSimulationTransaction';
import SimulationTestcases from '../../tabs/SimulationTestcases';
import TestsuiteTabs from "../../tabs/Testsuite";
import { Icon } from "@material-ui/core";
import HelpIcon from '@material-ui/icons/Help';
import OwnershipStatusLabel from "../../atoms/labels/OwnershipStatusLabel";

export default function RightDrawer() {
    const [item, setItem] = useState(null);
    const [key, setKey] = useState(Math.random(1, 100));

    const containerStyle = {
        width: '1000px',
        display: 'block',
        background: 'transparent'
    }

    const dispatch = useDispatch();
    const drawerStatus = useSelector(getRightDrawerStatus);
    const elementOnFocus = useSelector(getElementOnFocus);
    const tabOnFocus = useSelector(getTabOnFocus)
    const handlerEditStatus = useSelector(getCodeEditStatus);
    const clusterlets = useSelector(getClusterlets);
    const events = useSelector(getEvents);
    const templatesClusterlet = useSelector(getTemplateClusterlets);
    const views = useSelector(getViews);

    const { screen } = getDetailsFromUrl();


    const transactions = useSelector(getAllTransactions);
    const transactionState = useSelector(getTransactionState);
    const drawnTransactionState = useSelector(getTransactionDrawnState)
    const dashboardPreviewItems = ['clusterlet', 'analytics'];
    const [dashboardPreviewDialog, setDashboardPreviewDialog] = useState(false)
    const [showTour, setTour] = useState(false)



    useEffect(() => {

        if (elementOnFocus != null) {
            let el = findItem(elementOnFocus.id, elementOnFocus.type);
            setItem(el)
        }
        setKey(Math.random(1, 100));

    }, [elementOnFocus, events, clusterlets, transactions])


    const closeRightDrawer = () => {
        if (handlerEditStatus) {
            dispatch(setIsDocumentClicked());
            return;
        }
        
        if(showTour){
            dispatch(triggerTour({currentTour: ''}))
        }

        if (transactionState.drawEvent === true || transactionState.drawNestedTransaction == true || transactionState.drawReuseTransaction == true || drawnTransactionState == true || (elementOnFocus && elementOnFocus?.id === null && elementOnFocus?.type === 'event')) {
            dispatch(reRenderInfoBuilder());
            dispatch(setTRansactionState(false));
            dispatch(setDrawnTransaction(false))
        }
        dispatch(setFocusElement({}));
        dispatch(toggleRightDrawer());
        dispatch(setNodeClicked({}));
        dispatch(setLatestFieldAdded([]));
        dispatch(setDisablePan(false));
        dispatch(setTabOnFocus(0));
        dispatch(resetImageMapData());
        let typesNotIn = screen === 'transaction' ? 'transaction' : screen === 'view' ? 'view' : [];
        dispatch(invokePostService('removeLocks', { typesNotIn }, []));
    }

    const findItem = (id, type) => {
        let clusterletsGroups = ['clusterlet', 'external_function', 'analytics', 'sensor', 'user', 'controller_delegate'];
        let eventGroups = ['event'];
        let transactionGroups = ['transaction'];


        if (clusterletsGroups.includes(type)) {
            return elementOnFocus;
        } else if (eventGroups.includes(type)) {
            if (elementOnFocus.templateEvent !== undefined) {
                return { ...elementOnFocus.templateEvent, type: 8 }
            }
            return { id: elementOnFocus.id, item: elementOnFocus.item ? elementOnFocus.item : null, name: elementOnFocus.name !== undefined ? elementOnFocus?.name : 'Create event', type: 8, protocol: elementOnFocus.protocol, action: elementOnFocus?.action }
        } else if (transactionGroups.includes(type)) {
            // return decideCreateOrEditTransaction(id);
            return { id: id, name: elementOnFocus?.name, type: 7, uuid: elementOnFocus?.uuid, action: elementOnFocus?.action };
        } else if (type == 'nested_transaction') {

            return { id: id, name: elementOnFocus?.name, type: 9 };
        } else if (type === 'event_types') {
            return { name: 'Event Types', type: 'event_types', action: elementOnFocus?.action, screen: elementOnFocus?.screen }
        } else if (type === 'import_messages') {
            return { name: 'Import Event Types', type: 'import_messages', screen: elementOnFocus?.screen }
        } else if (type === 'templated_clusterlet') {
            return templatesClusterlet.find(c => c.id === id)
        } else if (type === 'templated_transaction') {
            return { ...elementOnFocus.item, id: elementOnFocus.id }
        } else if (type === 'view') {
            const viewName = elementOnFocus.action === "create" ?"Create View" :  views.name ;
            return { type: elementOnFocus.type, id: elementOnFocus.id, name: viewName, action: elementOnFocus.action }
        } else if (type === 'section') {
            return { type: elementOnFocus.type, id: elementOnFocus.id, name: elementOnFocus.name ? elementOnFocus.name : "Create Section" }
        } else if (type === 'field') {
            return { type: elementOnFocus.type, id: elementOnFocus.id, name: elementOnFocus.name ? elementOnFocus.name : "Create Field" }
        } else if (type === 'ui') {
            return { type: elementOnFocus.type, id: elementOnFocus.id, name: elementOnFocus.name ? elementOnFocus.name : "Create Widget" }
        } else if (type === 'assets_file' || type === 'assets_folder') {
            return { type: elementOnFocus.type, name: elementOnFocus.type === 'assets_folder' ? "Create Directory" : "Upload Assets" }
        }
        else if (type === 'assets_rename') {
            return { type: elementOnFocus.type, name: 'Rename Asset', item: elementOnFocus.item, parent: elementOnFocus.parent }
        }
        else if (type === 'template_delegate') {
            return { type: elementOnFocus.type, name: elementOnFocus.name ? elementOnFocus.name : "Template Delegate", templateId: elementOnFocus.templateId ? elementOnFocus.templateId : '' }
        } else if (type === 'simulation') {
            return { type: elementOnFocus.type, id: elementOnFocus.id, name: elementOnFocus.name ? elementOnFocus.name : "Create Simulation", description: elementOnFocus.description, action: elementOnFocus.action }
        }else if (type === 'testsuite') {
            return { type: elementOnFocus.type, id: elementOnFocus.id, action: elementOnFocus.action, name: elementOnFocus.name ? elementOnFocus.name : "Create Testsuite", description: elementOnFocus.description };
        }
        else if (type === 'eventPayload') {
            return { type: elementOnFocus.type, id: elementOnFocus.id, name: elementOnFocus.name ? elementOnFocus.name : "Event Name", simulation_transaction_id: elementOnFocus.simulation_transaction_id }
        }
        else if (type === 'simulationTransaction') {
            return { type: elementOnFocus.type, simulation_transaction_id: elementOnFocus.simulation_transaction_id, name: elementOnFocus.name, testcase_id: elementOnFocus.testcase_id }
        }
        else if (type === 'childSimulationTransaction') {
            return { type: elementOnFocus.type, simulation_transaction_id: elementOnFocus.simulation_transaction_id, name: elementOnFocus.name, testcase_id: elementOnFocus.testcase_id, conditionFlag: elementOnFocus.conditionFlag, loopFlag: elementOnFocus.loopFlag, testcase_name: elementOnFocus.testcase_name }
        }
        else if (type === 'simulation_testcases') {
            return { type: elementOnFocus.type, id: elementOnFocus.id, name: elementOnFocus.name, description: elementOnFocus.description, action: elementOnFocus.action, testsuiteId: elementOnFocus?.activeTestsuite?._id?.toString(), activeTestsuite: elementOnFocus?.activeTestsuite?.name}
        }

        else {
            // console.error('Unknown right drawer item!', elementOnFocus)
        }

        return null;
    }

    const decideCreateOrEditTransaction = (id, type) => {
        if (id == null) {
            return { name: 'Create transaction', type: 7 }
        } else {
            return { id: id, name: elementOnFocus?.name, type: 7 }
        }
    }

    const decideCreateOrEditEvent = id => {
        if (id == null) {
            return { ...elementOnFocus.item, name: 'Create event', type: 8, id: elementOnFocus.id }
        } else {
            return { ...elementOnFocus.item, type: 8, id: elementOnFocus.id }
        }
    }

    const transactionGroups = [7, 9, 19];

    const dashboardPreview = () => {
        setDashboardPreviewDialog(true)
    }

    const handleManualTour = () => {
        switch(item.type){
            case 'simulation_testcases':
                dispatch(triggerTour({currentTour: 'testcaseRightDrawer', initStart: true}))
                break;
            case "testsuite":
                dispatch(triggerTour({currentTour: 'testsuiteRightDrawer', initStart: true}))
                break;
            case 8:
                let tour = 'eventsDrawer'
                if(tabOnFocus === 6 || tabOnFocus === 5){
                   tour = 'eventHandler'
                }
                dispatch(triggerTour({currentTour: tour, initStart: true}))
                break;
            case 'analytics':
                dispatch(triggerTour({currentTour: 'clusterletDrawer', initStart: true}))
                break;
            case 'clusterlet':
                dispatch(triggerTour({currentTour: 'digitalTwinDrawer', initStart: true}))
                break;
            case 'external_function':
                dispatch(triggerTour({currentTour: 'delegateDrawer', initStart: true}))
                break;
            default: 
                break;
        }
        
    }


    useEffect(() => {
        if(['simulation_testcases', 'analytics', 'clusterlet', 'external_function', 'testsuite',8].includes(item?.type)){
            setTour(true)
        }else{
            setTour(false)
        }

        return () => {
            if(showTour){
                dispatch(triggerTour({currentTour: ''}))
            }
        }
    },[item])
    

    return (

        <Drawer
            id={"right_drawer"}
            style={{ position: "relative", marginTop: 100 }}
            hideBackdrop
            anchor={"right"}
            open={drawerStatus && !elementOnFocus?.transaction && item?.screen !== "transaction"}
            className={"rightDrawerContainer"}
            onClose={(drawerStatus) => { }}
        >

            <AppBar position="static">
                <Toolbar>
                    <Grid container>
                        <Grid item xs={2}>
                        </Grid>
                        <Grid item xs={8} align={'center'} direction={'column'} justify={'center'}>
                            {item == null && 
                                <div style={{height: '100%', width: '100%'}}>
                                    <h5>Loading...</h5>
                                </div>
                            }

                            {item != null && <div style={{ display: 'flex', alignItems: 'center', gap: 3, justifyContent: 'center' }}> 
                            <h5 style={{ marginTop: 10 }}><DrawerHeader className="right-drawer-title" item={item} name={item?.activeTestsuite ? `${item.activeTestsuite} | ${item.name}` : item.name} /> </h5>
                            <OwnershipStatusLabel entity={item} style={{marginLeft: 3}}/>
                            </div>
                            }
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            {
                                showTour &&
                                <Tooltip title='Show Tour'>
                                    <Icon onClick={handleManualTour} style={{height: '2rem', width: 'auto',color: 'rgba(0, 0, 0, 0.54)', display: 'flex',justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                                      <HelpIcon/>
                                    </Icon>
                                </Tooltip>
                            }
                            <Tooltip title="Close configuration panel">
                                <IconButton id={"close_rightdrawer_button"} onClick={closeRightDrawer}><CancelIcon /></IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>

            {item != null && <div className="container-right" style={containerStyle}>
                {(item.type == 'external_function' || item.type == 'controller_delegate') && <Delegate element={item} key={key} />}
                {item.type == 'clusterlet' && <DigitalTwin element={item} key={key} />}
                {item.type == 'sensor' && <Sensor element={item} key={key} />}
                {/* {item.type == 8 && <Event element={item} key={key} />} */}
                {item.type == 'analytics' && <Analytics element={item} key={key} />}
                {item.type == 'user' && <User element={item} key={key} />}
                {transactionGroups.includes(item.type) && <Transaction element={item} />}
                {item.type === 'event_types' && item.screen !== "transaction" && <EventTypes element={item} />}
                {item.type === 23 && <TemplateClusterlet element={item} key={key} />}
                {/* {item.type === 24 && <Transaction element={item} key={key} />} */}
                {/* {item.type === 'view' && <View element={item} key={key} />} */}
                {/* {item.type === 'section' && <ViewSection element={item} key={key} />} */}
                {item.type === 'field' && <ViewField element={item} key={key} />}
                {/* {item.type === 'ui' && <ViewUI element={item} key={key} />} */}
                {item.type === 'assets_file' && <Assets element={item} key={key} />}
                {item.type === 'assets_folder' && <Assets element={item} key={key} />}
                {item.type === 'assets_rename' && <Assets element={item} key={key} />}
                {item.type === 'template_delegate' && <TemplateDelegate element={item} key={key} />}
                {item.type === 'import_messages' && item.screen !== "transaction" && <EventTypes element={item} />}
                {item.type === 'testsuite' && <TestsuiteTabs element={item} />}
                {item.type === 'simulation' && <SimulationTabs element={item} />}
                {item.type === 'eventPayload' && <SimulationEvent element={item} />}
                {item.type === 'simulationTransaction' && <SimulationTransaction element={item} />}
                {item.type === 'simulation_testcases' && <SimulationTestcases element={item} />}
                {item.type === 'childSimulationTransaction' && <ChildSimulationTransaction element={item} />}


            </div>}

            {item == null && <p>Loading...</p>}

            {/* {dashboardPreviewDialog && <ClusterletDashboard clusterlet={elementOnFocus} ClusterletDashboardDialog={setDashboardPreviewDialog} />} */}

        </Drawer>

    )
}